export enum UsersSettingsFilterItemType {
  PROTECTED_APP = "protectedApp",
}
